export default __webpack_public_path__ + "static/media/varicosevein.6447ba1f.svg";